import { SITE } from "../data/site";
import { useT } from "../i18n/LanguageContext";

export const About = () => {
  const { t } = useT();
  const features = t("about.features"); // array

  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 bg-[var(--ivory)] noise-bg relative">
      <div className="max-w-7xl mx-auto px-5 md:px-10 relative">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5">
            <div className="gold-divider justify-start">
              <span className="line" />
              <span className="text-[11px] tracking-[0.3em] uppercase">{t("about.kicker")}</span>
            </div>
            <h2 className="mt-6 font-display text-5xl md:text-6xl text-[var(--espresso)] leading-[1] tracking-tight-elegant">
              {t("about.titlePre")} <span className="italic font-serif-elegant text-[var(--gold-deep)]">{t("about.titleEm")}</span>.
            </h2>

            <p className="mt-8 text-[var(--espresso-soft)] leading-[1.85] text-base md:text-[17px]">{t("about.p1")}</p>
            <p className="mt-5 text-[var(--espresso-soft)] leading-[1.85] text-base md:text-[17px]">{t("about.p2")}</p>

            <div className="mt-10 inline-flex items-center gap-4 px-6 py-4 bg-[var(--cream)] border border-[var(--sand)]">
              <span className="font-serif-elegant italic text-2xl text-[var(--gold-deep)]">"</span>
              <span className="text-[var(--espresso-soft)] italic text-sm">{t("about.quote")}</span>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-6">
              {Array.isArray(features) && features.map((f, i) => (
                <div
                  key={i}
                  data-testid={`feature-card-${String(i + 1).padStart(2, "0")}`}
                  className="group bg-[var(--cream)] border border-[var(--sand)]/70 p-7 transition-all duration-500 hover:border-[var(--gold)] hover:-translate-y-1 hover:shadow-[0_18px_40px_-20px_rgba(140,110,51,0.25)]"
                >
                  <div className="flex items-baseline justify-between mb-4">
                    <span className="font-display text-3xl text-[var(--gold-deep)]">{String(i + 1).padStart(2, "0")}</span>
                    <span className="h-px w-10 bg-[var(--gold)]/50 group-hover:w-16 transition-all" />
                  </div>
                  <h3 className="font-display text-2xl text-[var(--espresso)] mb-2">{f.title}</h3>
                  <p className="text-[var(--warm-gray)] text-sm leading-relaxed">{f.text}</p>
                </div>
              ))}
            </div>

            <div className="mt-8 grid grid-cols-3 gap-3">
              <div className="img-card aspect-square">
                <img src={SITE.images.pizzaSiciliana} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="img-card aspect-square">
                <img src={SITE.images.pizzaPesto} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="img-card aspect-square">
                <img src={SITE.images.pizzaDiavola} alt="" className="w-full h-full object-cover" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
